import svg4everybody from 'svg4everybody';
import 'jquery-match-height';
import 'jquery-touchswipe';
import 'bootstrap-sass';
// import OverlayScrollbars from 'overlayscrollbars';

export default class Global {
  init() {
    const navbarCollapse = $('.navbar-collapse');
    let windowWidth = $(window).innerWidth();
    let windowHeight = $(window).innerHeight();
    let navbarHeight = $('.navbar-main').innerHeight();


    function pageWrapperPadding() {
      $('.page-wrapper').css('paddingTop', navbarHeight);
    }

    function calcOnResize() {
      windowWidth = $(window).innerWidth();
      windowHeight = $(window).innerHeight();
      navbarHeight = $('.navbar-main').innerHeight();
      if (windowWidth <= '991') {
        navbarHeight = $('.navbar-header').innerHeight();
      }

      $('.carousel .carousel-inner').css('height', 'auto');
    }

    function navbarCollapseHeight() {
      let callNowBtnHeight = $('.call-now-btn').innerHeight();

      $('.navbar-collapse').css('max-height', windowHeight - navbarHeight - callNowBtnHeight);
    }

    function collapseNavbar() {
      if (windowWidth > 991) {
        navbarCollapse.addClass('no-transition');
      } else {
        navbarCollapse.removeClass('no-transition');
      }

      navbarCollapse.collapse('hide');
    }

    // Run on load func
    function runOnLoad(arrFunctions) {
      $.each(arrFunctions, ((i, arrFunc) => {
        arrFunc();
      }));
    }

    // Run on resize func
    function runOnResize(arrFunctions) {
      $.each(arrFunctions, ((i, arrFunc) => {
        arrFunc();
      }));
    }

    let onResizeArrFuncs = [
      calcOnResize,
      pageWrapperPadding,
      navbarCollapseHeight
    ];

    const runOnceOnBreakpointChangeFuncs = [
      collapseNavbar
    ];

    let breakpoint;

    // Run once on breakpoint change
    function runOnceOnBreakpointChange(arrFunctions) {
      if (windowWidth <= 991 && breakpoint !== 'mobile') {
        $.each(arrFunctions, ((i, arrFunc) => {
          arrFunc();
        }));

        breakpoint = 'mobile';
        return;
      }

      if (windowWidth > 991 && breakpoint !== 'desktop') {
        $.each(arrFunctions, ((i, arrFunc) => {
          arrFunc();
        }));

        breakpoint = 'desktop';
      }
    }

    // Run on resize
    $(window).resize(() => {
      runOnResize(onResizeArrFuncs);
      runOnceOnBreakpointChange(runOnceOnBreakpointChangeFuncs);
    });

    let onLoadArrFuncs = [
      svg4everybody,
      calcOnResize,
      pageWrapperPadding,
      navbarCollapseHeight
    ];

    // Run on load
    runOnLoad(onLoadArrFuncs);
    runOnceOnBreakpointChange(runOnceOnBreakpointChangeFuncs);

    // Overlay Scrollbars - Need to test before Init
    // OverlayScrollbars(document.querySelectorAll('body'), {});

    // Overflow toggle wrapper/body for navbar collapse
    navbarCollapse.on('show.bs.collapse', (() => {
      $('.page-wrapper').addClass('overflow-y-hidden');
    }));

    navbarCollapse.on('hide.bs.collapse', (() => {
      $('.page-wrapper').removeClass('overflow-y-hidden');
    }));

    // Match height
    $('.feature-pod').matchHeight({
      byRow: false
    });

    const matchHeightSelectorsThatStartWith = [
      '*[class^="split-content-"]',
      '*[class^="equal-table-"]',
      '*[class^="two-cols-"]'
    ];

    const matchHeightSelectors = [
      '.icon-pod',
      '.mobile-list li',
      '.tab-column',
      '.split-hero-equal-col',
      '.equal-height-col'
    ];

    $.each(matchHeightSelectorsThatStartWith, ((i, selector) => {
      $(selector).matchHeight();
    }));

    $.each(matchHeightSelectors, ((i, selector) => {
      $(selector).matchHeight();
    }));

    $.fn.matchHeight._maintainScroll = true;

    // Carousel swipe
    $('.carousel').swipe({
      swipeLeft: swipeCarousel,
      swipeRight: swipeCarousel,
      allowPageScroll: 'vertical'
    });

    function swipeCarousel(event, direction, distance, duration, fingerCount) {
      const swipeDirection = direction !== 'right' ? 'next' : 'prev';
      $(this).carousel(swipeDirection);
    }

    // Carousel height transition
    $('.carousel').carousel().on('slide.bs.carousel', function (e) {
      const nextH = $(e.relatedTarget).height();
      $(this).find('.active').parent().animate({ height: nextH }, 500);
    });

    // Form handling
    var $form = $('.contact-form'),
      $formMessages = [];
    $formMessages['success'] = $('.form-messages__success'),
    $formMessages['failure'] = $('.form-messages__failure');

    $form.submit(function(event){
      event.preventDefault();
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: $form.serialize()
      }).done(function(response) {
        $formMessages['success'].show();
        $form.find(':input').val('');
        setTimeout(function(){
          $formMessages['success'].hide(500);
        }, 4000);
        ga('send', 'event', 'Form Submited', 'page: ' + document.title, breakpoint);
      }).fail(function(data) {
        $formMessages['failure'].show();
        $form.find(':input').val('');
        setTimeout(function(){
          $formMessages['failure'].hide(500);
        }, 4000);
      })
    })

    // Call now btn
    $('*[data-phone]')
      .on('click', function(e) {
        if (breakpoint === 'desktop') {
          e.preventDefault();
          $(this).text($(this).data('phone'));
        }
        ga('send', 'event', 'Call Now', document.title, breakpoint);
      });

    // Cost tabs section toggle bg img
    $('.section-cost-tabs a[data-toggle="tab"]')
      .on('shown.bs.tab', ((e) => {
        $(e.relatedTarget)
          .closest('.section')
          .toggleClass('men-bg');
      }));

    // Pricetable class toggle
    $('.table-responsive')
      .on('touchstart click mouseover', function(e) {
        $(this).addClass('no-icon')
      });

    // Events
    $('*[data-location-link]')
      .on('click', function(e) {
        ga('send', 'event', 'Location Link', 'page: ' + document.title, breakpoint);
      });

    $('*[data-social-icon]')
      .on('click', function(e) {
        ga('send', 'event', 'Social Icon', 'page: ' + document.title + ', social-icon: ' + $(this).data('social-icon'), breakpoint);
      });

    $('#faq-accordion').on('show.bs.collapse', function (e) {
      ga('send', 'event', 'FAQ', 'page: ' + document.title + ', question: ' + $(e.target).prev('.panel-heading').find('a').clone().children().remove().end().text(), breakpoint);
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/global.js